import React, { useState } from 'react';
import { Grid, Paper, Typography, Divider, Step, Stepper, Box, StepButton, Button, FormControlLabel, Checkbox } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { PaymentForm, CreditCard, GooglePay, ApplePay } from 'react-square-web-payments-sdk';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        justifyContent: 'center',
        padding: theme.spacing(4),
    },
}));

const CheckoutForm = (props) => {

    const MuiClasses = useStyles();
    const sandbox = process.env.NODE_ENV === 'development';
    const appID = sandbox ? process.env.REACT_APP_SQUARE_SANDBOX_APPLICATION_ID : process.env.REACT_APP_SQUARE_APPLICATION_ID ;
    const locationID = sandbox ? process.env.REACT_APP_SQUARE_SANDBOX_LOCATION_ID : process.env.REACT_APP_SQUARE_LOCATION_ID ;
    const [activeStep, setActiveStep] = useState(0);
    const steps = ['Customer Info', 'Payment']
    const handleStep = (number) => { setActiveStep(number); };
    const canHalfPay = props.cartFees.halfCost > 0.00;
    return (
        <Paper className={MuiClasses.paper}>
            <Box sx={{ width: '100%' }}>
                <Stepper activeStep={activeStep}>
                    {steps.map((label, index) => (
                    <Step key={label}>
                        <StepButton color="inherit" onClick={() => { handleStep(index) }}>
                        {label}
                        </StepButton>
                    </Step>
                    ))}
                </Stepper>
                {activeStep === 0 
                ?
                    <form
                        onSubmit={(event) => { 
                            event.preventDefault()

                            if(props.validateCheckoutFields(event)){
                                if(Number(props.cartFees.total.toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2)) > 0){
                                    //props.generateSquareToken(event);
                                    handleStep(1)
                                }else if(Number(props.cartFees.total.toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2)) === 0){
                                    props.setProcessing(true)
                                    props.onSuccessfulPayment(null, true)
                                }else{
                                    throw new Error('Total is a negative number!');
                                }
                            } 
                        }}  
                    >
                        <Grid container spacing={2}>
                            <Grid item md={6} xs={12}>
                                {props.createInput(props.formElementsArray[0])}
                            </Grid>
                            <Grid item md={6} xs={12}>
                                {props.createInput(props.formElementsArray[1])}
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <Typography>Preferred Contact Method</Typography>
                                {props.createInput(props.formElementsArray[13])}
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <Divider style={{margin:'1px'}}/>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                {props.createInput(props.formElementsArray[2])}
                            </Grid>
                            <Grid item md={12} xs={12}>
                                {props.createInput(props.formElementsArray[12])}
                            </Grid> 
                            <Grid item md={12} xs={12}>
                                {props.createInput(props.formElementsArray[3])}
                            </Grid>
                            <Grid item md={8} xs={12}>
                                {props.createInput(props.formElementsArray[4])}
                            </Grid>
                            <Grid item md={4} xs={12}>
                                {props.createInput(props.formElementsArray[5])}
                            </Grid>
                            <Grid item md={5} xs={12}>
                                {props.createInput(props.formElementsArray[8])}
                            </Grid>
                            <Grid item md={4} xs={12}>
                                {props.createInput(props.formElementsArray[7])}
                            </Grid>
                            <Grid item md={3} xs={12}>
                                {props.createInput(props.formElementsArray[6])}
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    variant='contained'
                                    fullWidth
                                    disabled={props.processing}
                                    size='large'
                                    type='submit'>
                                    {props.processing ? "Processing..." : "Continue To Payment"}
                                </Button>
                            </Grid>
                        </Grid>

                        {props.checkoutError.map((msg) => {
                            return(
                                <Typography style={{ color: 'red' }}>{msg} **</Typography>
                            )
                        })}
                        {props.paymentErrors.map((err) => {
                            return(
                                <Typography style={{ color: 'red' }}>{err.detail}</Typography>
                            )
                        })}

                        <Typography style={{ color: 'red' }}>{props.paymentFailed ? "There was an error regarding your payment, please try again." : null}</Typography>
                    </form>
                :
                    <PaymentForm
                        //sandbox={sandbox}
                        applicationId={appID}
                        locationId={locationID}
                        cardTokenizeResponseReceived={(token) => { props.handlePayment(token); }}

                        //dont fully understand this yet, used for google and apple pay
                        createPaymentRequest={() => ({
                            countryCode: "CA",
                            currencyCode: "CAD",
                            total: {
                            amount: Number(props.cartFees.total.toFixed(2) - Number(props.cartFees.giftCardApplied).toFixed(2)).toFixed(2),
                            label: "Total",
                            },
                        })}
                    >
                        
                        <Grid item xs={12}>
                        {props.processing || (!props.accepted && props.payingHalf) ? null :
                        <Grid xs={12}>
                            <Divider/>
                            <Typography variant={'caption'}>
                                <b>Disclaimer: </b>We deliver to the edge of your property only, defined as the nearest point accessible directly from a public road. 
                                If you request that our vehicle go beyond this point, you accept full responsibility for any damage to lawns, driveways, sidewalks, or other structures.
                                <br/>
                                <br/>
                                By proceeding with this order, you confirm that all product selections and the delivery address are correct. 
                                Any changes after delivery may incur additional charges.
                            </Typography>
                        </Grid>
                        }
                            <CreditCard 
                                buttonProps={{
                                    isLoading: props.processing || (!props.accepted && props.payingHalf),
                                    css: {
                                        backgroundColor: "#ffc107",
                                        color: "black",
                                        '&:hover': {
                                            backgroundColor: !props.processing && "#ffc107",
                                            color: !props.processing && "black",
                                          },
                                    },
                                }}
                            />
                            {props.processing || (!props.accepted && props.payingHalf) ? null :
                            <GooglePay style={{marginTop:'10px'}}/>}
                            {props.processing || (!props.accepted && props.payingHalf) ? null :
                            <ApplePay style={{marginTop:'10px'}}/>}
                            {props.processing && <Typography style={{ color: 'black' }}>Processing... Please do not leave or refresh this page.</Typography>}
                        </Grid>
                        {props.paymentErrors.map((err) => {
                        return(
                            <Typography style={{ color: 'red' }}>{err.detail}</Typography>
                        )
                        })}

                       {canHalfPay && 
                        <Grid xs={12}>
                            <Divider/>
                            <Typography>This order is eligible for Half Now & Half Later! </Typography>
                        </Grid>
                        }
                        {canHalfPay && <FormControlLabel 
                        control={<Checkbox checked={props.payingHalf} onChange={()=>{props.setPayingHalf(!props.payingHalf)}} />} 
                        label="Pay Half Now & Half Later" />}
                        {props.payingHalf && 
                        <Grid xs={12}>
                            <Divider/>
                            <Typography variant={'caption'}>By accepting to pay Half Now & Half Later, you agree that your customer information and payment card information will be securely stored for the sole purpose of processing the future payment upon completion of your transaction. 
                                This data will not be sold, shared, or used for any purposes other than to complete payments through Square Payments. All information will be handled in compliance with applicable privacy laws, 
                                and you can rest assured that your data will be protected through industry-standard security measures.
                                For more information on how your data is used and protected, please refer to our Privacy Policy and Square’s privacy terms.<br/><br/>The second payment will be charged following the completion of your order.</Typography>
                        </Grid>
                        }
                        {props.payingHalf && <FormControlLabel 
                        control={<Checkbox checked={props.accepted} onChange={()=>{props.setAccepted(!props.accepted)}} />} 
                        label="I Accept the Terms & Conditions." />}

                    </PaymentForm>
                }
            </Box>
        </Paper>
    )
}

export default CheckoutForm;